export default __webpack_public_path__ + "static/media/TNCLogo.4fe66466.png";